import React, { ReactNode } from "react";
import SidebarAnalysis from "../../components/sidebar/SidebarAnalysis";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import Layout from "./Layout";

export default function AnalysisLayout({ children }: { children: ReactNode }) {
	const isSmallScreen = useMediaQuery('(max-width: 980px)');
	return (
	<>
		<Layout>
			<div className="route-grid">
				{/* {!isSmallScreen && <SidebarAnalysis />} */}
				{<SidebarAnalysis isSmallScreen={isSmallScreen} />}

				<main className="main-container">{children}</main>
			</div>
		</Layout>
	</>
	);
}
